import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const categoryTile = Joi.object({
  code: Joi.string().required(),
  image: Joi.string().required(),
  name: Joi.string().required(),
  categoryId: Joi.number().allow(null),
  url: Joi.string().allow('', null),
  type: Joi.string().valid('category').required()
}).unknown(true);
const promotionTile = Joi.object({
  code: Joi.string().required(),
  backgroundColor: Joi.string().allow('', null),
  iconName: Joi.string().required(),
  iconColor: Joi.string().allow('', null),
  name: Joi.string().required(),
  url: Joi.string().allow('', null),
  type: Joi.string().valid('promotion').required()
}).unknown(true);
const buttonTile = Joi.object({
  code: Joi.string().required(),
  backgroundColor: Joi.string().allow('', null),
  textColor: Joi.string().allow('', null),
  title: Joi.string().required(),
  description: Joi.string(),
  url: Joi.string().allow('', null),
  type: Joi.string().valid('button').required()
}).unknown(true);
const categoryTilesSchema = Joi.object({
  type: Joi.string().valid('categoryTiles').required(),
  code: Joi.string().allow('', null).required(),
  tiles: Joi.array().items(Joi.alternatives().try(categoryTile, promotionTile, buttonTile)),
  ...blockAppearanceSchema
}).unknown(true);
export default categoryTilesSchema;